import ContactMain from "./ContactMain/ContactMain";
import OfficeLocations from "./OfficeLocations/OfficeLocations";
import SEO from "../../components/SEO";

export default function Contacts({ currentLanguage = "en" }) {
  // SEO titles based on language
  const pageTitles = {
    en: "Contact Us",
    fr: "Contactez-nous", // ✅ correct French
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />
      <ContactMain currentLanguage={currentLanguage} />
      <OfficeLocations currentLanguage={currentLanguage} />
    </>
  );
}
